module.exports = __webpack_public_path__ + "static/img/volkswagen-competition.735266e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/volkswagen-competition.jpg
// module id = oa3F
// module chunks = 0